
export class NyrsetupDefinitiontilesContext {
    constructor() {

    }
}
